import {MaybeArchivableItem} from 'archive/ArchiveConstants';
import isArchived from 'archive/isArchived';

import {SchemaField} from './SchemaFieldConstants';

export function getSchemaFieldArchivableItem(
  field: SchemaField
): Omit<SchemaField, 'id'> & MaybeArchivableItem {
  return {...field, id: field.apiId};
}

export default function isSchemaFieldArchived(field: SchemaField): boolean {
  return isArchived(getSchemaFieldArchivableItem(field));
}
